














import { Component, Vue, Watch } from 'vue-property-decorator';
import VueRouter from 'vue-router';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Tab from '@/components/Tab/Tab.vue';
import api, { apiProduction, apiSandbox } from '@/libs/api';
import Information from './Edit/Information.vue';
// import FilterRole from './components/Filter/UserRole.vue';

Vue.use(VueRouter);

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Tab,
    Information,
  },
})
export default class BcaVirtualAccount extends Vue {
  name?: string | null = '';
  tabs = [{
    label: 'Information',
    to: 'information',
  }];

  get type() {
    return this.$route.params.type;
  }

  @Watch('$route')
  onRouteChange() {
    this.name = this.$route.name;
  }

  mounted() {
    this.name = this.$route.name;
    this.checkIsMerchantReseller();
  }

  async checkIsMerchantReseller() {
    const id = this.$route.params.type;
    try {
      // this.loading = true;
      const { data } = await api.get(`/res/check-merchant-reseller/${id}`);
      if (data.main_reseller === false) {
        this.tabs.push({
          label: 'Channels',
          to: 'channels',
        });
      }

      if (data.main_reseller === false && data.sub_reseller === false) {
        this.tabs.push({
          label: 'Reseller',
          to: 'reseller',
        });
      }

      if (data.main_reseller === true && data.sub_reseller === false) {
        this.tabs.push({
          label: 'Reseller',
          to: 'reseller',
        });
      }
    } catch (err) {
      console.error(err);
      // showToast(ToastType.FAILED, 'Error', (err as any).response.data.error.errors.map((e: any) => e.message));
    }
    // this.loading = false;
  }
}
